<template>
    <div>
        <p class="text-subtitle1">
            Select clients to unassign them from the user.
        </p>
        <client-search-input v-model="keyword" filled outlined dense />
        <user-clients-table
                :user-id="user.id"
                :keyword="keyword"
                v-model:selected="selected"
                class="q-mt-md"
                ref="userClients"
        />
        <div class="text-center q-mt-md">
            <async-btn
                    v-show="selected.length"
                    :task="task"
                    label="Unassign"
                    color="primary"
                    @click="unassign"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { User, UserClient, List } from '@/type';
import ClientSearchInput from '@/client/ClientSearchInput.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import UserClientsTable from './UserClientsTable.vue';
import { unassignAll } from './user-client';

interface Data {
  keyword: string|null,
  selected: UserClient[],
  task: Promise<any>|null,
}

export default defineComponent({
  components: {
    ClientSearchInput,
    UserClientsTable,
    AsyncBtn,
  },
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  data(): Data {
    return {
      keyword: null,
      selected: [],
      task: null,
    };
  },
  methods: {
    unassign(): void {
      this.task = unassignAll(this.selected);
      this.task.then(() => {
        const name = `${this.user.firstName} ${this.user.lastName}`;
        const total = this.selected.length;
        notify(
          `Unassigned ${total} client${(total === 1) ? '' : 's'} from ${name}`,
        );

        this.selected.forEach((uc) => {
          (this.$refs.userClients as List).removeItem(uc);
        });
        this.selected = [];
      });
    },
  },
});
</script>
